import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as ReasonActions from './reason.actions';
import ReasonService from '../../services/ReasonService';
import { mergeMap, map } from 'rxjs';
import { Reason } from '../../models/Reason';

@Injectable()
export class ReasonEffects {
  getReasons$;

  constructor(private actions$: Actions, private reasonService: ReasonService) {
    this.getReasons$ = createEffect(() =>
      this.actions$.pipe(
        ofType(ReasonActions.getReasons),
        mergeMap(() =>
          this.reasonService.getReasons().pipe(
            map((reasons: Reason[]) => ReasonActions.getReasonsSuccess({ reasons }))
          )
        )
      )
    );
  }
}
